import { render, staticRenderFns } from "./filters-item.vue?vue&type=template&id=df0cec28"
import script from "./filters-item.vue?vue&type=script&lang=js"
export * from "./filters-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports